const NOW_MS = Date.now();
const HOUR_MS = 60 * 60 * 1000;
const DAY_MS = 24 * HOUR_MS;

export const BASEMAP_LAYERS = {
  landfire240: {
    name: "Landfire 240 (LF2023 Prerelease)",
    type: "raster",
    tilesUrl:
      "https://lfps.usgs.gov/arcgis/rest/services/Landfire_LF2024/LF2024_FBFM40_CONUS/ImageServer/exportImage?bbox={bbox-epsg-3857}&bboxSR=3857&size=512%2C512&imageSR=3857&time=&format=png&pixelType=S16&noData=&noDataInterpretation=esriNoDataMatchAny&interpolation=+RSP_NearestNeighbor&compression=&compressionQuality=&bandIds=&sliceId=&mosaicRule=&renderingRule=&adjustAspectRatio=true&validateExtent=false&lercVersion=1&compressionTolerance=&f=image",
    tileSize: 512,
    rasterOpacity: 0.75,
  },
  landfire230: {
    name: "Landfire 230",
    type: "raster",
    tilesUrl:
      "https://lfps.usgs.gov/arcgis/rest/services/Landfire_LF2024/LF2024_FBFM40_CONUS/ImageServer/exportImage?bbox={bbox-epsg-3857}&bboxSR=3857&size=512%2C512&imageSR=3857&time=&format=png&pixelType=S16&noData=&noDataInterpretation=esriNoDataMatchAny&interpolation=+RSP_NearestNeighbor&compression=&compressionQuality=&bandIds=&sliceId=&mosaicRule=&renderingRule=&adjustAspectRatio=true&validateExtent=false&lercVersion=1&compressionTolerance=&f=image",
    tileSize: 512,
    rasterOpacity: 0.75,
  },
  osm_nonburnable: {
    // Non-burnable features derived from OSM (golf courses, orchards,
    // vineyards, cemeteries, managed farmland, etc.). Loaded on demand from
    // the backend for the current viewport, so it has no tile URL.
    name: "OSM Non-Burnables",
    type: "osmMask",
  },
  landfire_dist: {
    name: "Landfire Disturbance",
    type: "raster",
    tilesUrl:
      "https://lfps.usgs.gov/arcgis/rest/services/Landfire_LF2024/LF2024_FDist_CONUS/ImageServer/exportImage?bbox={bbox-epsg-3857}&bboxSR=3857&size=256%2C256&imageSR=3857&time=&format=png&pixelType=S16&noData=&noDataInterpretation=esriNoDataMatchAny&interpolation=+RSP_NearestNeighbor&compression=&compressionQuality=&bandIds=&sliceId=&mosaicRule=&renderingRule=&adjustAspectRatio=true&validateExtent=false&lercVersion=1&compressionTolerance=&f=image",
    tileSize: 256,
    rasterOpacity: 0.75,
  },
  topo: {
    name: "USGS Topos",
    type: "raster",
    tilesUrl:
      "https://services.arcgisonline.com/ArcGIS/rest/services/USA_Topo_Maps/MapServer/tile/{z}/{y}/{x}",
    tileSize: 256,
    rasterOpacity: 0.75,
  },
  cpad: {
    name: "California Public Lands",
    type: "raster",
    tilesUrl:
      "https://gis.cnra.ca.gov/arcgis/rest/services/Boundaries/CPAD_AgencyLevel/MapServer/export?dpi=96&transparent=true&format=png32&layers=show%3A1&bbox={bbox-epsg-3857}&bboxSR=3857&size=512%2C512&imageSR=3857&imageSR=2857&size=512,512&f=image",
    tileSize: 512,
    rasterOpacity: 0.65,
  },
  sdi: {
    name: "Suppression Difficulty",
    type: "raster",
    tilesUrl:
      "https://imagery.geoplatform.gov/iipp/rest/services/Fire_Aviation/USFS_EDW_SAB_WildfireSuppressionDifficultyIndex97thPerc/ImageServer/exportImage?f=image&bbox={bbox-epsg-3857}&bboxSR=3857&size=512%2C512&imageSR=3857&time=&format=jpeg&pixelType=S16&format=jpgpng&mosaicRule=%7B%22ascending%22%3Atrue%2C%22mosaicMethod%22%3A%22esriMosaicNorthwest%22%2C%22mosaicOperation%22%3A%22MT_FIRST%22%7D",
    tileSize: 512,
    rasterOpacity: 0.65,
  },
  landfire_dist_2022: {
    name: "Landfire Disturbance 2022",
    type: "raster",
    tilesUrl:
      "https://lfps.usgs.gov/arcgis/rest/services/Landfire_Disturbance/LF2022_Dist22_CONUS/ImageServer/exportImage?bbox={bbox-epsg-3857}&bboxSR=3857&size=256%2C256&imageSR=3857&time=&format=png&pixelType=S16&noData=&noDataInterpretation=esriNoDataMatchAny&interpolation=+RSP_NearestNeighbor&compression=&compressionQuality=&bandIds=&sliceId=&mosaicRule=&renderingRule=&adjustAspectRatio=true&validateExtent=false&lercVersion=1&compressionTolerance=&f=image",
    tileSize: 256,
    rasterOpacity: 0.75,
  },
  landfire_dist_2021: {
    name: "Landfire Disturbance 2021",
    type: "raster",
    tilesUrl:
      "https://lfps.usgs.gov/arcgis/rest/services/Landfire_Disturbance/LF2022_Dist21_CONUS/ImageServer/exportImage?bbox={bbox-epsg-3857}&bboxSR=3857&size=256%2C256&imageSR=3857&time=&format=png&pixelType=S16&noData=&noDataInterpretation=esriNoDataMatchAny&interpolation=+RSP_NearestNeighbor&compression=&compressionQuality=&bandIds=&sliceId=&mosaicRule=&renderingRule=&adjustAspectRatio=true&validateExtent=false&lercVersion=1&compressionTolerance=&f=image",
    tileSize: 256,
    rasterOpacity: 0.75,
  },
  landfire_dist_2020: {
    name: "Landfire Disturbance 2020",
    type: "raster",
    tilesUrl:
      "https://lfps.usgs.gov/arcgis/rest/services/Landfire_Disturbance/LF2020_Dist20_CONUS/ImageServer/exportImage?bbox={bbox-epsg-3857}&bboxSR=3857&size=256%2C256&imageSR=3857&time=&format=png&pixelType=S16&noData=&noDataInterpretation=esriNoDataMatchAny&interpolation=+RSP_NearestNeighbor&compression=&compressionQuality=&bandIds=&sliceId=&mosaicRule=&renderingRule=&adjustAspectRatio=true&validateExtent=false&lercVersion=1&compressionTolerance=&f=image",
    tileSize: 256,
    rasterOpacity: 0.75,
  },
  landfire_dist_2019: {
    name: "Landfire Disturbance 2019",
    type: "raster",
    tilesUrl:
      "https://lfps.usgs.gov/arcgis/rest/services/Landfire_Disturbance/LF2020_Dist19_CONUS/ImageServer/exportImage?bbox={bbox-epsg-3857}&bboxSR=3857&size=256%2C256&imageSR=3857&time=&format=png&pixelType=S16&noData=&noDataInterpretation=esriNoDataMatchAny&interpolation=+RSP_NearestNeighbor&compression=&compressionQuality=&bandIds=&sliceId=&mosaicRule=&renderingRule=&adjustAspectRatio=true&validateExtent=false&lercVersion=1&compressionTolerance=&f=image",
    tileSize: 256,
    rasterOpacity: 0.75,
  },
  landfire_dist_2018: {
    name: "Landfire Disturbance 2018",
    type: "raster",
    tilesUrl:
      "https://lfps.usgs.gov/arcgis/rest/services/Landfire_Disturbance/LF2020_Dist18_CONUS/ImageServer/exportImage?bbox={bbox-epsg-3857}&bboxSR=3857&size=256%2C256&imageSR=3857&time=&format=png&pixelType=S16&noData=&noDataInterpretation=esriNoDataMatchAny&interpolation=+RSP_NearestNeighbor&compression=&compressionQuality=&bandIds=&sliceId=&mosaicRule=&renderingRule=&adjustAspectRatio=true&validateExtent=false&lercVersion=1&compressionTolerance=&f=image",
    tileSize: 256,
    rasterOpacity: 0.75,
  },
  currentFires: {
    name: "Current Fires",
    type: "featureService",
    url: "https://services3.arcgis.com/T4QMspbfLg3qTGWY/arcgis/rest/services/WFIGS_Interagency_Perimeters_Current/FeatureServer/0/",
    style: {
      type: "fill",
      paint: {
        "fill-opacity": 0.4,
        "fill-color": "red",
        "fill-outline-color": "darkred",
      },
      label: {
        "text-field": [
          "format",
          ["upcase", ["get", "attr_IncidentName"]],
          { "font-scale": 0.9 },
        ],
      },
    },
  },
  firisFires: {
    name: "FIRIS Fire Perimeters (CA)",
    type: "featureService",
    url: "https://services5.arcgis.com/bz1uwWPKUInZBK94/arcgis/rest/services/CA_Perimeters_NIFC_FIRIS_public_view/FeatureServer/0/",
    style: {
      type: "fill",
      layout: {
        "fill-sort-key": [
          "-",
          0,
          ["to-number", ["get", "poly_DateCurrent"], 0],
        ],
      },
      paint: {
        "fill-opacity": 0.2,
        "fill-color": [
          "interpolate",
          ["linear"],
          ["to-number", ["get", "poly_DateCurrent"], 0],
          NOW_MS - 7 * DAY_MS,
          "#ffffb2",
          NOW_MS - 2 * DAY_MS,
          "#fecc5c",
          NOW_MS - 12 * HOUR_MS,
          "#fd8d3c",
          NOW_MS - HOUR_MS,
          "#f03b20",
          NOW_MS,
          "#bd0026",
        ],
      },
      outline: {
        layout: {
          "line-sort-key": [
            "-",
            0,
            ["to-number", ["get", "poly_DateCurrent"], 0],
          ],
        },
        paint: {
          "line-width": 3,
          "line-color": [
            "interpolate",
            ["linear"],
            ["to-number", ["get", "poly_DateCurrent"], 0],
            NOW_MS - 7 * DAY_MS,
            "#b39200",
            NOW_MS - 2 * DAY_MS,
            "#a35a00",
            NOW_MS - 12 * HOUR_MS,
            "#8c2d04",
            NOW_MS - HOUR_MS,
            "#7a0177",
            NOW_MS,
            "#67000d",
          ],
        },
      },
      label: {
        "text-field": [
          "format",
          ["upcase", ["get", "incident_name"]],
          { "font-scale": 0.9 },
        ],
      },
    },
  },
  historicFires: {
    name: "Historic Fires",
    type: "featureService",
    url: "https://services3.arcgis.com/T4QMspbfLg3qTGWY/arcgis/rest/services/InterAgencyFirePerimeterHistory_All_Years_View/FeatureServer/0/",
    style: {
      type: "fill",
      paint: {
        "fill-opacity": 0.4,
        "fill-color": "orange",
        "fill-outline-color": "red",
      },
      label: {
        "text-field": [
          "format",
          ["upcase", ["get", "INCIDENT"]],
          { "font-scale": 0.9 },
          "\n",
          {},
          ["downcase", ["get", "FIRE_YEAR"]],
          { "font-scale": 0.8 },
        ],
      },
    },
  },
  rawsStations: {
    name: "RAWS Stations",
    type: "featureService",
    url: "https://services3.arcgis.com/T4QMspbfLg3qTGWY/arcgis/rest/services/PublicView_RAWS/FeatureServer/1/",
    style: {
      type: "circle",
      paint: {
        "circle-radius": 6,
        "circle-color": "blue",
      },
      label: {
        "text-field": [
          "format",
          ["upcase", ["get", "StationName"]],
          { "font-scale": 0.9 },
          "\n",
          {},
          ["downcase", ["get", "NWSID"]],
          { "font-scale": 0.8 },
        ],
        "text-variable-anchor": ["top", "bottom", "left", "right"],
        "text-radial-offset": 0.5,
      },
    },
  },
};

// Derive an ArcGIS ImageServer `identify` endpoint for every raster basemap
// backed by an ImageServer. Left-clicking such a layer can then report the
// pixel value at that point (e.g. the LANDFIRE fuel model). Tile-based
// (MapServer/tile) and MapServer/export layers don't expose this and are
// left without an identifyUrl.
Object.values(BASEMAP_LAYERS).forEach((config) => {
  if (
    config.type === "raster" &&
    typeof config.tilesUrl === "string" &&
    config.tilesUrl.includes("/ImageServer/exportImage")
  ) {
    config.identifyUrl = config.tilesUrl.split("/exportImage")[0] + "/identify";
  }
});

function addBasemaps(map) {
  Object.entries(BASEMAP_LAYERS).forEach(([id, config]) => {
    if (config.type === "featureService" || config.type === "osmMask") {
      return;
    }

    map.addSource(id, {
      type: config.type,
      tiles: [config.tilesUrl],
      tileSize: config.tileSize,
    });

    map.addLayer(
      {
        id: id,
        type: "raster",
        source: id,
        paint: {
          "raster-opacity": config.rasterOpacity,
        },
        layout: {
          visibility: "none",
        },
      },
      "waterway-label"
    );
  });
}

export function addMapSourcesAndLayers(map) {
  addBasemaps(map);

  map.addSource("overlay", {
    type: "raster",
    tiles: [
      "https://svc-raster-tiles-b3i5nh3t5a-uw.a.run.app/cog/tiles/WebMercatorQuad/{z}/{x}/{y}@2x?url=https://cdn.xyloplandev.net/modeling/core/70c07804-6832-4662-a5e1-139d065912d7/d07b34df-3993-4f27-b370-9eb2b5e5ca52/wind_speed.tif",
    ],
    tileSize: 512,
  });

  map.addLayer(
    {
      id: "overlay",
      type: "raster",
      source: "overlay",
      paint: {
        "raster-opacity": 0.9,
      },
      layout: {
        visibility: "none",
      },
    },
    "waterway-label"
  );

  map.addSource("overlay-vector", {
    type: "geojson",
    data: { type: "FeatureCollection", features: [] },
  });

  map.addLayer(
    {
      id: "overlay-vector",
      type: "fill",
      source: "overlay-vector",
      paint: {
        "fill-opacity": 0.9,
        "fill-color": "purple",
      },
      layout: {
        visibility: "none",
      },
    },
    "waterway-label"
  );

  // OSM non-burnable base layer. Data is populated for the current viewport by
  // MapStateContext when this basemap is selected.
  map.addSource("osm-nonburnable", {
    type: "geojson",
    data: { type: "FeatureCollection", features: [] },
  });

  map.addLayer(
    {
      id: "osm-nonburnable",
      type: "fill",
      source: "osm-nonburnable",
      paint: {
        "fill-opacity": 0.5,
        "fill-color": "#7b3294",
      },
      layout: {
        visibility: "none",
      },
    },
    "waterway-label"
  );

  map.addLayer(
    {
      id: "osm-nonburnable-outline",
      type: "line",
      source: "osm-nonburnable",
      paint: {
        "line-color": "#40004b",
        "line-width": 1,
      },
      layout: {
        visibility: "none",
      },
    },
    "waterway-label"
  );
}
